import React from 'react';
import { QuickDrawer } from 'shared/components/QuickDrawer';
import { EditUserInner } from 'shared/account/pages/EditUser/EditUser';
import { Button } from './styled';
import styled from 'styled-components';

const Padding = styled.div`
  padding: 0 20px;
  height: calc(100vh - var(--app-header-height) - 50px);
  overflow-y: auto;
`;

export const EditUser = React.memo(({
  isUserDrawerOpen,
  handleEditDrawerClose,
  accountId,
  usernameForEdit,
  selectedUser,
  setSelectedUser,
  listUsers,
  onDirty
}) => {
  return (
    <QuickDrawer
      open={isUserDrawerOpen}
      title="Edit User"
      width="450px"
      onClose={handleEditDrawerClose}
    >
      <Padding>
        {usernameForEdit && <EditUserInner
          accountId={accountId}
          username={usernameForEdit}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          extraButtons={<Button onClick={handleEditDrawerClose}>Cancel</Button>}
          isDrawer={true}
          refreshUserList={listUsers}
          onDirty={onDirty}
        />}
      </Padding>
    </QuickDrawer>
  );
});
